import React from "react";
import { Button, FormControl, Modal, ControlLabel, Checkbox, Alert } from "react-bootstrap";
import immutable from "immutable";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import moment from "moment";
import util from "../../lib/util.js";


export default class TimecardLineCopy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            errorMsg: "",
            disableSave: false,
            sourceDates: [],
            targetDates: [],
            inputs: {
                    peopleId: null,
                    targetTimecardId: null,
                    sourceWorkDate: "",
                    targetWorkDates: []
                }
        };

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.save = this.save.bind(this);
        this._handleChange = this._handleChange.bind(this);
    }

    open() {
        const self = this;
        const clone = immutable.fromJS(this.state).toJS();
        clone.inputs.sourceWorkDate = "";
        clone.inputs.targetWorkDates = [];
        clone.showDialog = true;

        let url = 'tcline-copy';
        if (!util.isStringNullOrEmpty(self.props.timecardId))
            url += `/${self.props.timecardId}`;
        else if (!util.isStringNullOrEmpty(self.props.peopleId))
            url += `-new-timecard/${self.props.peopleId}`;

        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        ajax.vm()
            .get(url)
            .then(res => {
                clone.sourceDates = res.data.recentDailyWorkHours.map(o => ({ workDate: moment(o.workDate).format("MM/DD/YYYY"), workHours: o.workHours }));
                clone.targetDates = res.data.targetDailyWorkHours.map(o => ({ workDate: moment(o.workDate).format("MM/DD/YYYY"), workHours: o.workHours }));
                self.setState(clone);

                context.message({
                    show: false,
                });
            })
            .catch(function (err) {
                let data = err.response ? err.response.data : err;
                clone.errorMsg = data.exceptionMessage || data.message;
                self.setState(clone);

                context.message({
                    show: false,
                });
            });
    }

    save() {
        const self = this;
        const request = immutable.fromJS(self.state.inputs).toJS();
        request.peopleId = this.props.peopleId;
        request.targetTimecardId = this.props.timecardId;

        const msg = this.validate(request);
        if (msg != "") {
            self.setState({ errorMsg: msg });
            return;
        }

        context.message({
            show: true,
            type: "loading",
            message: "Copying. Please wait..."
        });

        ajax.api()
            .post("copy-timecard-line", request)
            .then(function (res) {
                let clone = immutable.fromJS(self.state).toJS();
                clone.errorMsg = "";
                clone.showDialog = false;
                self.setState(clone);
                
                if (self.props.onCopy) {
                    const timecard = { data: { timecardId: res.data } };
                    self.props.onCopy(timecard);
                }
                else {
                    context.message({
                        show: false,
                    });
                }
            })
            .catch(function (err) {
                let data = err.response ? err.response.data : err;
                self.setState({ errorMsg: data.exceptionMessage || data.message });

                context.message({
                    show: false,
                });
            });
    }

    close() {
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({ showDialog: false, errorMsg: "" })
            .toJS());
    }

    validate(obj) {
        if (util.isStringNullOrEmpty(obj.sourceWorkDate)) {
            return "Copy From is required";
        }

        if (obj.targetWorkDates == null || obj.targetWorkDates.length == 0) {
            return "Copy To is required";
        }

        return "";
    }

    _handleChange(evt) {
        const self = this;
        const clone = immutable.fromJS(this.state.inputs).toJS();
        const field = evt.target;

        if (field.name == "targetWorkDates") {
            if (field.checked === true && !clone.targetWorkDates.includes(field.value))
                clone.targetWorkDates.push(field.value);
            else if (field.checked === false && clone.targetWorkDates.includes(field.value))
                clone.targetWorkDates = clone.targetWorkDates.filter(d => d != field.value);
        }
        else {
            clone[field.name] = field.value;
        }

        self.setState({ inputs: clone, errorMsg: "" });
    }

    render() {
        const self = this;
        const isMobile = util.isMobile();
        const inputs = this.state.inputs;
        const errorMsg = this.state.errorMsg;

        return (
            <Modal show={this.state.showDialog} >
                <Modal.Header >
                    <Modal.Title>Quick Copy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="ap-timecard-line-copy">
                        <div className="row">
                            <div className="col-xs-12 col-md-2">
                                <ControlLabel>Copy From:</ControlLabel>
                            </div>
                            <div className="col-xs-12 col-md-10">
                                <FormControl componentClass="select" name="sourceWorkDate"
                                    value={inputs.sourceWorkDate}
                                    onChange={this._handleChange}>
                                    <option key="-1" value="">Please select...</option>
                                    {
                                        self.state.sourceDates.map((d, idx) => 
                                                <option key={idx} value={d.workDate}>
                                                    {`${moment(d.workDate).format("dddd MMM DD, YYYY")} - ${d.workHours} work hours logged`}
                                                </option>)
                                    }
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 hidden-md hidden-lg ap-mt-1">
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-2">
                                <ControlLabel>Copy To:</ControlLabel>
                            </div>
                            <div className="col-xs-12 col-md-10">
                                <div className="row">
                                    <div className="col-xs-12 col-md-12 target-dates">
                                    {
                                        self.state.targetDates.map((d, idx) => 
                                                <div className="day-option" key={idx}>
                                                    <div className={d.workHours > 0 ? "day-name disabled": "day-name"}>
                                                        {moment(d.workDate).format('ddd')}
                                                    </div>
                                                    <Checkbox value={d.workDate}
                                                        name="targetWorkDates"
                                                        onChange={this._handleChange}
                                                        checked={inputs.targetWorkDates.includes(d.workDate)} 
                                                        disabled={d.workHours > 0}></Checkbox>
                                                </div>
                                            )
                                    }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-md-12 caption">
                                        The "Copy To" feature only applies to days that have 0 hours logged.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={errorMsg.length > 0 ? "row" : "hidden"}>
                            <div className="col-xs-12 col-md-12 error-panel">
                                <Alert bsStyle="danger">
                                    {errorMsg}
                                </Alert>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div className="row">
                        <div className="col-xs-12 col-md-4 ap-top-margined">
                            <Button className="btn-info ap-fullsize" onClick={this.save} disabled={self.state.disableSave}>Save</Button>
                        </div>
                        <div className="hidden-xs col-md-4 ap-top-margined"></div>
                        <div className="col-xs-12 col-md-4 ap-top-margined">
                            <Button className="btn-info ap-fullsize" onClick={this.close}>Cancel</Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}